// extracted by mini-css-extract-plugin
export default {"container":"Card1_container__tcUZG","field":"Card1_field__AqPHD"};